var _get = require('lodash.get');
var trackingIds = require('../utils/constants').trackingIds;

function track(pageId, linkId) {
    if (!linkId) {
        return;
    }
    var GHUtil = _get(window, 'GH.Util');
    var finalPageId = pageId || (GHUtil ? GHUtil.getPageID() : '');
    var sid = 'p' + finalPageId + '.m' + trackingIds.moduleId + '.l' + linkId;

    /*
    TODO: convert raptor tracking to pulsar using the following model
    var eventData = {
        eventFamily: 'FOLLOW',
        eventAction: 'ACTN',
        actionKind: 'CLICK',
        operationId: finalPageId,
        flushImmediately: false,
        eventProperty: {
            moduledtl: 'mi:' + trackingIds.moduleId + '|li:' + linkId
        }
    };
    dispatch('pulsar', eventData);
    */
    dispatch('rover', { sid: sid });
}

function pulsar(eventData) {
    if (!eventData) {
        return;
    }
    var finalData = eventData;
    if (typeof eventData === 'string') {
        finalData = JSON.parse(eventData);
    }
    dispatch('pulsar', finalData);
}

function dispatch(eventName, eventData) {
    var event;
    if (window.CustomEvent && typeof window.CustomEvent === 'function') {
        event = new CustomEvent(eventName, { detail: eventData });
    } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, eventData);
    }
    document.dispatchEvent(event);
}

// Returns a stringified version of the tracking object specified by actionKind. Default=CLICK
function getAsString(trackingList, actionKind) {
    var finalTracking = trackingList || [];
    var finalActionKind = actionKind || 'CLICK';
    var trackingOut;
    finalTracking.forEach(function(tracking) {
        if (tracking && tracking.actionKind === finalActionKind) {
            try {
                trackingOut = JSON.stringify(tracking);
            } catch (e) {
                console.log(e); // eslint-disable-line no-console
            }
        }
    });
    return trackingOut;
}

module.exports = {
    track: track,
    pulsar: pulsar,
    getAsString: getAsString
};
